import React from 'react';
import { AboutMe } from '../components/aboutme';
import { Intro } from '../components/intro';
import { Experience } from '../components/experience';
import BookSection from '../components/BookSection';
import ArticlesSection from '../components/ArticlesSection';
import { Testimonials } from '../components/Testimonials';
import { Findme } from '../components/findme';
import { Footer } from '../components/footer';
import SEO from '../components/SEO';

const myBook = {
  title: "Designing Scalable System",
  subtitle: "The Art of Growth: Scalable Solutions for Tomorrow",
  coverImage: "/book.jpeg",
  description:
    "ALHAMDULILLAH! Holding my book for the first time is a surreal moment— a result of passion, dedication, and hard work. Grateful to co-author this with Huzaifa Asif and excited to share this journey with you all...",
  link: "https://www.amazon.com/Designing-Scalable-Systems-Solutions-Tomorrow/dp/B0CS77KBB2/ref=tmm_hrd_swatch_0?_encoding=UTF8&qid=&sr=",
};

// JSON-LD structured data for SEO and GEO
const personSchema = {
  "@context": "https://schema.org",
  "@type": "Person",
  "name": "Asim Hafeez",
  "url": "https://asimhafeez.com",
  "image": "https://asimhafeez.com/asim.jpg",
  "jobTitle": ["Senior Software Engineer", "Engineering Lead"],
  "description": "Senior Software Engineer, Engineering Lead, and System Architect specializing in scalable systems, AI engineering, blockchain, and cloud architecture. Author of 'Designing Scalable Systems'. Currently leading backend engineering at Evert (Norway) and pursuing a Micro Masters at MIT.",
  "worksFor": {
    "@type": "Organization",
    "name": "Evert",
    "url": "https://evert.no/"
  },
  "hasOccupation": {
    "@type": "Occupation",
    "name": "Backend Engineering Lead",
    "occupationalCategory": "15-1252.00",
    "skills": "Software Engineering, System Architecture, AI Engineering, Cloud Architecture, Microservices, Backend Development"
  },
  "alumniOf": [
    {
      "@type": "CollegeOrUniversity",
      "name": "Massachusetts Institute of Technology",
      "url": "https://www.mit.edu/",
      "department": "Statistics and Data Science"
    }
  ],
  "knowsAbout": [
    "Software Engineering", "System Architecture", "AI Engineering",
    "Machine Learning", "Blockchain", "Smart Contracts", "Cloud Architecture",
    "AWS", "Microservices", "React", "Node.js", "TypeScript",
    "LangChain", "LangGraph", "System Design", "Data Science",
    "Go", "NestJS", "PostgreSQL", "MongoDB", "Redis", "DynamoDB",
    "Kafka", "Docker", "Kubernetes", "Vector Databases", "Agentic AI"
  ],
  "nationality": {
    "@type": "Country",
    "name": "Pakistan"
  },
  "knowsLanguage": ["English", "Urdu"],
  "email": "mailto:asimhafeezz@icloud.com",
  "sameAs": [
    "https://linkedin.com/in/asimhafeezz",
    "https://github.com/asimhafeezz",
    "https://twitter.com/asimhafeezz",
    "https://instagram.com/asimhafeezz",
    "https://huggingface.co/asimhafeez",
    "https://medium.com/@asimhafeez"
  ]
};

// ProfilePage schema wrapping the Person — signals this is a personal profile page
const profilePageSchema = {
  "@context": "https://schema.org",
  "@type": "ProfilePage",
  "mainEntity": personSchema,
  "dateCreated": "2024-01-01",
  "dateModified": "2026-02-24",
  "name": "Asim Hafeez — Portfolio",
  "description": "Professional portfolio of Asim Hafeez, Engineering Lead and Senior Software Engineer specializing in scalable systems, AI engineering, and cloud architecture."
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Asim Hafeez",
  "url": "https://asimhafeez.com",
  "description": "Portfolio of Asim Hafeez — Senior Software Engineer, Engineering Lead, System Architect, Tech Lead, and Book Author. Showcasing projects, articles, certifications, and the book 'Designing Scalable Systems'.",
  "author": {
    "@type": "Person",
    "name": "Asim Hafeez"
  },
  "inLanguage": "en-US"
};

export const HomePage: React.FC = () => {
  return (
    <div style={{
      position: 'relative',
      zIndex: 10,
      background: 'transparent'
    }}>
      <SEO
        title="Asim Hafeez — Senior Software Engineer | Engineering Lead | System Architect | Book Author"
        description="Asim Hafeez is a Senior Software Engineer, Engineering Lead, and System Architect building scalable systems with expertise in AI engineering, blockchain, cloud architecture, and microservices. Author of 'Designing Scalable Systems'. Currently at Evert, Norway."
        canonicalUrl="/"
        keywords="asim hafeez, asim, asimhafeezz, senior software engineer, engineering lead, system architect, tech lead, AI engineering, blockchain, scalable systems, designing scalable systems, book author, cloud architecture, microservices, backend engineer, evert norway, MIT data science"
        jsonLd={[profilePageSchema, websiteSchema]}
      />
      <Intro />
      <AboutMe />
      <Experience />
      {/* <Education /> */}
      <BookSection book={myBook} />
      <ArticlesSection />
      <Testimonials />
      <Findme />
      <Footer />
    </div>
  );
};
